import { api, useCurrentUser } from '@cma/app'
import {
  DestroyPlatformClientFoldersMutation,
  DestroyPlatformClientFoldersMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useDestroyPlatformClientFolders() {
  const queryClient = useQueryClient()
  const { data: { currentUser } = {} } = useCurrentUser()

  return useMutation<
    DestroyPlatformClientFoldersMutation,
    Error,
    DestroyPlatformClientFoldersMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation DestroyPlatformClientFolders($ids: [ID!]!) {
          destroyPlatformClientFolders(ids: $ids) {
            errors
            deletedIds
          }
        }
      `
      return api<
        DestroyPlatformClientFoldersMutation,
        DestroyPlatformClientFoldersMutationVariables
      >({ query, variables })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries([
          'platformContent',
          { id: currentUser?.account?.id }
        ])
      }
    }
  )
}
